<script>
import common from '@/mixins/common.vue';
import { mapActions, mapGetters } from 'vuex';
import exportWord from 'export-docx';
import { saveInsureInfo } from '@/store/actions';
export default {
  name: 'CaseInsurePrintDialog',
  props: {
    visible: Boolean,
    item: Object,
    platform: Number,
    rowItem: Object,
  },
  data() {
    return {
      loading: false,
      valid: true,
      dialog: false,
      isVisible:false,
      text: '',
      displayId: '',
      saveLoading: false
    };
  },
  watch:{
    visible(value){
      this.isVisible = value;
    },
    isVisible(value){
      if(!value)
      {
        this.$emit('closeEvent');
      }
    },
    item(value){
      console.log(`item == ${JSON.stringify(value)}`);
    },
  },
  mixins: [common],
  computed:{
    ...mapGetters(['getUserInfo','getAgentList', ]),
  },
  methods: {
    ...mapActions(['fetchAgentList', 'saveInsureInfo']),
    async saveEvent(){
      try {
        if (this.displayId === ''){
          return;
        }
        this.saveLoading = true;
        this.item.displayId = this.displayId;
        const sqlResult = await this.saveInsureInfo(this.item);
        console.log(`saveInsureInfo ${JSON.stringify(sqlResult)}`);
        this.$emit('confirmEvent', true);
      } catch (e) {
        console.log(`save error` , e);
      } finally {
        this.saveLoading = false;
      }
    },
    optionEvent(eventKey) {
      const info = this.item;
      console.log(`eventKey ＝ ${eventKey} info == ${JSON.stringify(info)} , ${info.check1 === 1}`);
      if (eventKey === 0) {
        this.text = `${info.name}-和潤機車委對保<br/>
${info.guaranteeCash > 0 ? `收現${info.guaranteeCash}元<br/>` : ''}
${info.insureAmount > 0 ? `簽本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `簽本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `簽本票${info.insureAmount3}元(第三張)<br/>` : ''}
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}
線上設定版對保文件已傳PDF檔，請自行列印出來請申請人簽名；申請書請另外列印+內容填寫完整，謝謝`
      } else if (eventKey === 1) {
        this.text = `${info.name}-和潤機車委對保(借新還舊)<br/>
${info.guaranteeCash > 0 ? `收現${info.guaranteeCash}元<br/>` : ''}
${info.insureAmount > 0 ? `簽本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `簽本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `簽本票${info.insureAmount3}元(第三張)<br/>` : ''}
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}
線上設定版對保文件已傳PDF檔，請自行列印出來請申請人簽名；申請書請另外列印+內容填寫完整，謝謝`
      } else if (eventKey === 2) {
        this.text = `${info.name}-和潤機車委對保(原融自清)/(他行代償)<br/>
${info.guaranteeCash > 0 ? `收現${info.guaranteeCash}元<br/>` : ''}
${info.insureAmount > 0 ? `簽本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `簽本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `簽本票${info.insureAmount3}元(第三張)<br/>` : ''}
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}
線上設定版對保文件已傳PDF檔，請自行列印出來請申請人簽名；申請書請另外列印+內容填寫完整，謝謝`
      } else if (eventKey === 3) {
        this.text = `${info.name}-中租機車委對保<br/>
簽代扣同意書${this.getTotal(info)}元<br/>
委任代辦契約書${info.otherPrice2}元<br/>
${info.insureAmount > 0 ? `本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `本票${info.insureAmount3}元(第三張)<br/>` : ''}
${info.guaranteeCash > 0 ? `現金${info.guaranteeCash}元<br/>` : ''}
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}`

      } else if (eventKey === 4) {
        this.text = `${info.name}-中租機車委對保(借新還舊)<br/>
簽代扣同意書${this.getTotal(info)}元<br/>
委任代辦契約書${info.otherPrice2}元<br/>
${info.insureAmount > 0 ? `本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `本票${info.insureAmount3}元(第三張)<br/>` : ''}
${info.guaranteeCash > 0 ? `現金${info.guaranteeCash}元<br/>` : ''}
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}`
      } else if (eventKey === 5) {
        this.text = `${info.name}-中租機車委對保(他行代償)<br/>
簽代扣同意書${this.getTotal(info)}元<br/>
委任代辦契約書${info.otherPrice2}元<br/>
${info.insureAmount > 0 ? `本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `本票${info.insureAmount3}元(第三張)<br/>` : ''}
${info.guaranteeCash > 0 ? `現金${info.guaranteeCash}元<br/>` : ''}
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}`
      } else if (eventKey === 6) {
        this.text = `${info.name}-裕富機車N委對保<br/>
收代扣同意切結書${this.getTotal(info)}元(附檔)<br/>
${info.guaranteeCash > 0 ? `收現${info.guaranteeCash}元<br/>` : ''}
${info.insureAmount > 0 ? `簽本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `簽本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `簽本票${info.insureAmount3}元(第三張)<br/>` : ''}
代簽委任代辦契約書${info.otherPrice2}元<br/>
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}

文件第三人：請寫「張倫彬」
交易重要事項聲明書 : 內扣${info.beforePrice}(需對保當下填上，可告訴申請人，讓申請人自行填寫)

溫馨提醒
➊對保當下有任何問題請洽原業務或明昌經理，請對保員不用回答簽名以外的問題
➋切結書對保當下須再次確認申請人欲撥款的存封，請填寫上去+簽名
➌對保文件需正楷簽名，對保完成請先拍照上傳對保文件
`;
      } else if (eventKey === 7) {
        this.text = `${info.name}-裕富機車委對保<br/>
收代扣同意切結書${this.getTotal(info)}元(附檔)<br/>
${info.guaranteeCash > 0 ? `收現${info.guaranteeCash}元<br/>` : ''}
${info.insureAmount > 0 ? `簽本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `簽本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `簽本票${info.insureAmount3}元(第三張)<br/>` : ''}
代簽委任代辦契約書${info.otherPrice2}元<br/>
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}

文件第三人：請寫「張倫彬」
交易重要事項聲明書 : 內扣${info.beforePrice}(需對保當下填上，可告訴申請人，讓申請人自行填寫)

溫馨提醒
➊對保當下有任何問題請洽原業務或明昌經理，請對保員不用回答簽名以外的問題
➋切結書對保當下須再次確認申請人欲撥款的存封，請填寫上去+簽名
➌對保文件需正楷簽名，對保完成請先拍照上傳對保文件
`;
      } else if (eventKey === 8) {
        this.text = `${info.name}-裕富機車委對保(借新還舊)<br/>
收代扣同意切結書${this.getTotal(info)}元(附檔)<br/>
${info.guaranteeCash > 0 ? `收現${info.guaranteeCash}元<br/>` : ''}
${info.insureAmount > 0 ? `簽本票${info.insureAmount}元<br/>` : ''}
${info.insureAmount2 > 0 ? `簽本票${info.insureAmount2}元(第二張)<br/>` : ''}
${info.insureAmount3 > 0 ? `簽本票${info.insureAmount3}元(第三張)<br/>` : ''}
代簽委任代辦契約書${info.otherPrice2}元<br/>
${info.check1 === 1 ? `不收印章(也不收代刻費)，僅需簽代刻同意書即可<br/>` : ''}
${info.check2 === 1 ? `證件+行照+存封， 申請人若沒有列印，請再另外再拍清楚照片(彩檔)<br/>` : ''}
${info.check3 === 1 ? `收牌登(可影本或拍照，照片需清楚、完整)<br/>` : ''}
${info.check4 === 1 ? `設定中，免收牌登<br/>` : ''}
${info.check5 === 1 ? `收結清委託書(附檔)<br/>` : ''}

文件第三人：請寫「張倫彬」
交易重要事項聲明書 : 內扣${info.beforePrice}(需對保當下填上，可告訴申請人，讓申請人自行填寫)

溫馨提醒
➊對保當下有任何問題請洽原業務或明昌經理，請對保員不用回答簽名以外的問題
➋切結書對保當下須再次確認申請人欲撥款的存封，請填寫上去+簽名
➌對保文件需正楷簽名，對保完成請先拍照上傳對保文件
`;
      } else if (eventKey === 9){
        exportWord('https://rcdesign.io/temp/template_agent.docx', { otherPrice2: info.approvedNotePrice } , `${info.name}_委任代辦契約書.docx`)
      } else if (eventKey === 10){
        exportWord('https://rcdesign.io/temp/finatrade_template.docx', { carId: info.carId, creditPrice: info.creditPrice,
          total: info.approvedNotePrice , realPrice: info.realPrice} , `${info.name}_合迪扣款同意切結書1120621.docx`)
      } else if (eventKey === 11){
        exportWord('https://rcdesign.io/temp/loanhfc_template.docx', { carId: info.carId, creditPrice: info.creditPrice,
          total: info.approvedNotePrice , realPrice: info.realPrice} , `${info.name}_和潤扣款同意切結書1110223.docx`)
      } else if (eventKey === 12){
        exportWord('https://rcdesign.io/temp/rich_template.docx', { settingPrice: info.settingPrice, motoNPrice: info.motoNPrice, creditPrice: info.creditPrice,
          total: this.getTotal(info), otherPrice2:info.otherPrice2, check1:`${info.settingPrice > 0? '◼︎':'□'}`
          , check2:`${info.motoNPrice > 0? '◼︎':'□'}`, realPrice: info.realPrice} , `${info.name}_0927購物分期代扣費用同意切結書(通用版).docx`)
      } else {
        this.$emit('showEvent', { key: eventKey, info: info });
      }
    },
    confirmEvent(){
      this.$emit('confirmEvent', true);
    },
    getTotal(info){
      let total = 0;
      const otherPrice2 = info.otherPrice2 && info.otherPrice2!==''? info.otherPrice2 :0; // 其他衍伸費用
      const settingPrice = info.settingPrice && info.settingPrice!==''? info.settingPrice :0; // 機車動保設定費
      const motoNPrice = info.motoNPrice && info.motoNPrice!==''? info.motoNPrice :0; // 機車N對保費
      const beforePrice = info.beforePrice && info.beforePrice!==''? info.beforePrice :0; // 內扣款
      const originAmount = info.originAmount && info.originAmount!==''? info.originAmount :0; // 代償金額
      total = otherPrice2+settingPrice+motoNPrice+beforePrice+originAmount;
      return total;
    }
  }
};
</script>

<template>
  <v-dialog v-model="isVisible"
            persistent
            no-click-animation
            max-width="50%">
    <v-card>
      <v-card-text>
        <v-layout xs12>
          <v-flex xs6 >
            <v-btn class="primary" dark text @click="optionEvent(0)">和潤機車委對保文案</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(1)">和潤機車委對保(借新還舊)文案</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(2)">和潤機車委對保(原融自清)/(他行代償)文案</v-btn>
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs6 >
            <v-btn class="primary" dark text @click="optionEvent(3)">中租機車委對保文案</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(4)">中租機車委對保(借新還舊)文案</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(5)">中租機車委對保(他行代償)文案</v-btn>
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs6 >
            <v-btn class="primary" dark text @click="optionEvent(6)">裕富機車N委對保文案</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(7)">裕富機車委對保文案</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="primary" dark text @click="optionEvent(8)">裕富機車委對保(借新還舊)文案</v-btn>
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs6 >
            <v-btn class="success" dark text @click="optionEvent(9)">委任代辦契約書</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="success" dark text @click="optionEvent(10)">合迪扣款同意切結書1120621</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="success" dark text @click="optionEvent(11)">和潤扣款同意切結書1110223</v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="success" dark text @click="optionEvent(12)">0927購物分期代扣費用同意切結書(通用版)</v-btn>
          </v-flex>
        </v-layout>
        <v-layout xs12 mt-2>
          <v-flex>
            <p v-if="text" style="font-size: 16px; font-weight: 400;" v-html="text">
            </p>
          </v-flex>
        </v-layout>
        <v-divider/>
        <v-layout xs6 mt-2>
          <v-text-field v-model="displayId" label="補案件編號" outline></v-text-field>
          <v-btn color="primary" dark text :loading="saveLoading" @click="saveEvent()">儲存</v-btn>
        </v-layout>
        <br>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent">關閉</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CaseInsurePrintDialog.vue